import { gql } from "apollo-boost"

export const GET_PROJECT_MONTH_STATUS = gql`
  query getProjectMonthStatusBySubmission ($submissionId: ID!) {
    getProjectMonthStatusBySubmission(submissionId: $submissionId) {
      status
      year
      month
      id
      informationSentAt
      technicalMonitoringStatus
      financialMonitoringStatus
      financialMonitoringProjectStatus
      technicalMonitoringProjectStatus
      periodStatus
      prevPeriodStatus
    }
  }
`
